import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import LOOKUP from 'constants/lookup';
import WithRouter from 'custom/withRouter';
import { reportSalesCrumb } from 'utils/breadcrumbInfo';
import { getOrders } from 'actions/DashboardActions';
import { formInput, clearFormInput } from 'actions/FormActions';
import { getSalesSummary, downloadSalesSummary, getCsvReport } from 'actions/ReportsAction';
// Basic Components
import CardSimple from 'screens/components/basic/CardSimple';
import Button from 'screens/components/basic/Button';
import Grid from 'screens/components/basic/Grid';   
import KnowledgeBase from 'screens/components/basic/KnowledgeBaseIcon'
import DateCurrentDisplay from 'screens/containers/report/DateCurrentDisplay';
import Body from './Body';
import Header from './Header';

class SalesSummary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activePage: 1,
            itemsPerPage: 20,
            totalRow: 0,
            model: {
                branch: 0
            }
        };

    }

    componentWillMount() {
        const date = new Date();
        this.props.formInput(moment(date).format("YYYY-MM-DD"), `SalesSummarySelectedDate`);
    }

    downloadReport = () => {
        let branch = this.props.branch || this.props.loggedBranch;
        let selectedDate = this.props.selectedDate || moment().format("YYYY-MM-DD");
        this.props.getCsvReport(`reports/excel/salesummary?branch=${branch}&selectedDate=${selectedDate}`, "salessummary");
    }

    filter = () => {
        this.setState(pState => {
            return {
                ...pState,
                activePage: 1
            };
        }, this.getReport);
    }

    getReport = () => {
        let branch = this.props.branch ? parseInt(this.props.branch, 10) : this.props.loggedBranch;
        let selectedDate = this.props.selectedDate || moment().format("YYYY-MM-DD");
        //this.props.getOrders(branch);
        this.props.getSalesSummary({ branch: branch, selectedDate: selectedDate });

    }

    redirectToReport = () => {
        this.props.navigate("/report");
    }

    render() {
        return (
            <Grid headerContent={reportSalesCrumb}>
                <PageHeader title={LOOKUP.report.salesSummary.text}
                    icon={<KnowledgeBase link="https://knowledge.techpos.ca/en/knowledge/what-is-the-monthly-sales-summary-report" />}
                    description={LOOKUP.report.salesSummary.description}
                />
                <Header loggedBranch={this.props.loggedBranch} branchOptions={this.props.brachOptions} filter={this.filter} download={this.downloadReport} />
                <CardSimple>
                    <Body
                        orders={this.props.salesSummary || []}
                        reportDate={this.props.reportDate}
                    />
                    <DateCurrentDisplay />
                </CardSimple>
            </Grid>
        );
    }
}

const mapStateToProps = state => {
    let branches = state.common.userBranches || [];
    let brachOptions = [];
    branches.map((item) => {
        brachOptions.push({
            text: item.name, value: item.id.toString()
        });
    })
    return {
        brachOptions: brachOptions,
        //orders: state.dashboard.orders,
        reportDate: state.reports.salesSummary ? moment(state.reports.salesSummary.date).format('MMMM Do, YYYY') : moment().format('MMMM Do, YYYY'),
        salesSummary: state.reports.salesSummary.salesSummary,
        loggedBranch: state.common.branchId,
        branch: state.form.SalesSummaryBranchOption,
        selectedDate: moment(state.form.SalesSummarySelectedDate).format("YYYY-MM-DD"),
        data: state.reports.downloadSalesData,
        userBranchText: state.common.userBranches
    };
};

const mapDispatchToProps = dispatch => {
    return {
        //getOrders: (branchId) => dispatch(getOrders(branchId)),
        getSalesSummary: model => dispatch(getSalesSummary(model)),
        clearFormInput: (name) => dispatch(clearFormInput(name)),
        formInput: (value, name) => dispatch(formInput(value, name)),
        // downloadSalesSummary: (branch) => dispatch(downloadSalesSummary(branch)),
        getCsvReport: (url, name) => dispatch(getCsvReport(url, name))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(WithRouter(SalesSummary));